import { render, staticRenderFns } from "./FileSelecterClipper.vue?vue&type=template&id=4a493413&scoped=true&lang=pug"
import script from "./FileSelecterClipper.vue?vue&type=script&lang=ts"
export * from "./FileSelecterClipper.vue?vue&type=script&lang=ts"
import style0 from "./FileSelecterClipper.vue?vue&type=style&index=0&id=4a493413&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a493413",
  null
  
)

export default component.exports